export default __webpack_public_path__ + "static/media/gb-nir.d959bc60.svg";